
  import { PageTitle } from '@/ui/components/PageTitle';
  import { defineComponent, onMounted } from 'vue';
  import { Button } from '@/ui/components/Button';
  import { setLocale } from '@/ui/i18n/i18n';
  import { setUser } from '@/services/telemetry';
  import { hasSubscription, user } from '@/ui/auth/auth';
  import { pushRoute } from '@/ui/helpers/uiHelper';

  interface TopTitleSubtitlePageInterface {
    title: string;
    subtitle: string;
    ctaTitle?: string;
    ctaLink?: string;
  }

  export default defineComponent<TopTitleSubtitlePageInterface>({
    name: 'CenteredTitleSubtitlePage',
    components: { PageTitle, Button },
    props: ['title', 'subtitle', 'ctaTitle', 'ctaLink'],
    setup() {
      setUser(user.value);
      setLocale(user.value.locale);

      onMounted(() => {
        if (hasSubscription()) {
          pushRoute({ name: 'home' });
        }
      });
    },
  });
